import { render, staticRenderFns } from "./IdleOverlayComponent.vue?vue&type=template&id=5babe5f1&scoped=true"
import script from "./IdleOverlayComponent.vue?vue&type=script&lang=js"
export * from "./IdleOverlayComponent.vue?vue&type=script&lang=js"
import style0 from "./IdleOverlayComponent.vue?vue&type=style&index=0&id=5babe5f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5babe5f1",
  null
  
)

export default component.exports